export default {
	bizInspectStatisticsReport: {
		title: 'Statistical Report',
		dateRange: {
			startDate: 'Start Date',
			endDate: 'End Date',
			separator: 'to'
		},
		query: 'Query',
		export: 'Export',
		loading: 'Updating data, please wait...',
		updateSuccess: 'Data update completed',
		charts: {
			deviceRun: 'Device Operation Status',
			deviceWarn: 'Overall Alarm Status',
			deviceHealth: 'Overall Monitoring Status',
			warnType: 'Fault Type Statistics',
			deviceType: 'Plant Device Fault Statistics',
			warnTrend: 'Device Alarm Trend',
			warnList: 'Sensor Point Alarms',
			reportList: 'Fault Cases',
			mtbfStatistics: 'Device MTBF Statistics'
		},
		deviceRun: {
			total: 'Total',
			running: 'Running',
			stopped: 'Stopped',
			offline: 'Offline'
		},
		deviceWarn: {
			severe: 'Severe',
			medium: 'Medium',
			general: 'General',
			normal: 'Normal'
		},
		warnTrend: {
			generalAlarm: 'General Alarm',
			mediumAlarm: 'Medium Alarm',
			severeAlarm: 'Severe Alarm'
		},
		warnList: {
			index: 'Index',
			deviceName: 'Alarm Device',
			pointName: 'Alarm Point',
			reason: 'Alarm Reason',
			level: 'Alarm Level',
			time: 'Alarm Time',
			general: 'General',
			medium: 'Medium',
			severe: 'Severe',
			normal: 'Normal'
		},
		reportList: {
			index: 'Index',
			attachment: 'Case Attachment',
			type: 'Case Type',
			author: 'Author',
			time: 'Issue Time',
			healthReport: 'Health Report',
			diagnosisReport: 'Diagnosis Report'
		},
		mtbfStatistics: {
			index: 'Index',
			deviceName: 'Device Name',
			faultCount: 'Fault Count',
			avgInterval: 'Avg Interval (h)',
			lastFault: 'Last Fault'
		},
		deviceTypeChart: {
			title: 'Device Overview',
			total: 'Total',
			unit: 'units'
		},
		warnTypeChart: {
			title: 'Fault Type Statistics',
			total: 'Total',
			unit: 'cases'
		}
	}
}
